import React, { memo, useCallback, useState } from 'react'
import { ScrollArea } from '@mantine/core'
import { css } from '@emotion/css'
import { otherConfig } from './config/menu'

const subtleStyle = css`
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 8px;
`

const MenuItem = ({ config, active, onSelect }) => {
  return (
    <div
      className={css`
        height: 48px;
        display: flex;
        align-items: center;
        gap: 9px;
        color: rgba(0, 0, 0, 0.85);
        background-color: ${active === config.key
          ? 'rgba(0, 86, 254, 0.08)'
          : 'auto'};
        padding: 0 23px;
        user-select: none;
        cursor: pointer;
        border-radius: 6px;
      `}
      onClick={() => onSelect(config)}
    >
      {config.icon}
      <div>{config.title}</div>
    </div>
  )
}

const Sector = ({ title, configList, ...otherProps }) => {
  return (
    <div className="mb-5">
      <p className={subtleStyle}>{title}</p>
      {configList.map((c) => (
        <MenuItem key={c.key} config={c} {...otherProps} />
      ))}
    </div>
  )
}

const Connection = () => {
  return (
    <div
      className={css`
        padding: 0 23px;
      `}
    >
      <div
        className={css`
          width: 100px;
          height: 100px;
          background: rgba(0, 86, 254, 0.08);
          margin-bottom: 8px;
        `}
      />
      <p className={subtleStyle}>如果您有功能定制的需求，请扫码联系我们</p>
    </div>
  )
}

const Sider = () => {
  const [active, setActive] = useState('app-list')

  const onMenuSelect = useCallback((config) => {
    setActive(config.key)
  }, [])
  return (
    <div className="h-full bg-white" style={{ width: 280 }}>
      <ScrollArea className="h-full">
        <div className="p-5">
          {/* <Sector
            title="工作区"
            configList={workspaceConfig}
            active={active}
            onSelect={onMenuSelect}
          /> */}
          <Sector
            title="更多"
            configList={otherConfig}
            active={active}
            onSelect={onMenuSelect}
          />
          <Connection />
        </div>
      </ScrollArea>
    </div>
  )
}

export default memo(Sider)
